/**
 * A global namespace for `click` event.
 */
const mouseclickEvent = "click";
export default mouseclickEvent;
